import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { setLocals, VOLATILE_KEY_PREFIX } from './setLocals';
import initializeFirebase from './initializeFirebase';

export class FirebaseProvider extends React.PureComponent {
  state = {
    locals: {},
  };

  // https://github.com/facebook/react/issues/2517
  _localsChangedListeners = [];
  _localsObserver = {
    getCurrentLocals: () => this.state.locals,
    addLocalsChangedListener: (listener) =>
      (this._localsChangedListeners = _.uniq([
        ...this._localsChangedListeners,
        listener,
      ])),
    removeLocalsChangedListener: (listener) =>
      (this._localsChangedListeners = _.filter(
        this._localsChangedListeners,
        (l) => l !== listener
      )),
  };

  getChildContext() {
    const { firebase } = this.props;
    return {
      firebase,
      localsObserver: this._localsObserver,
    };
  }

  static childContextTypes = {
    firebase: PropTypes.object,
    localsObserver: PropTypes.object,
  };

  _unregisterListener = null;
  _unregisterAuthStateChanged = null;
  componentDidMount() {
    const { firebase } = this.props;

    this._unregisterAuthStateChanged = firebase
      .auth()
      .onAuthStateChanged((user) => {
        setLocals(firebase, { authorized: user && !user.isAnonymous });
        if (!user) {
          return;
        }

        const localsRef = firebase
          .firestore()
          .collection('locals')
          .doc(user.uid);

        this._unregisterListener = localsRef.onSnapshot((doc) => {
          const newLocals = doc.data() || {};
          this._localsChangedListeners.forEach((observer) =>
            observer(newLocals)
          );
          this.setState({
            locals: newLocals,
          });
        });

        // remove volatile fields
        setLocals(firebase, {
          [VOLATILE_KEY_PREFIX]: null,
        });
      });
  }

  UNSAFE_componentWillUnmount() {
    this._unregisterListener && this._unregisterListener();
    this._unregisterAuthStateChanged();
  }

  render() {
    const { children } = this.props;
    return children;
  }
}
